<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, required: true },
  description: { type: String, default: '' },
  confirmLabel: { type: String, default: 'Enviar' },
  loading: { type: Boolean, default: false },
  previewTitle: { type: String, default: 'Mensagem' },
  preview: { type: String, default: '' },
});

const emit = defineEmits(['close', 'confirm']);
const BACK_LABEL = 'Voltar';
</script>

<template>
  <LaisModal
    :show="show"
    :title="title"
    max-width-class="max-w-[560px]"
    @close="emit('close')"
  >
    <div class="grid gap-4">
      <p
        v-if="description"
        class="text-[14px] leading-relaxed text-lais-text-body"
      >
        {{ description }}
      </p>
      <section
        class="rounded-lais-sm border border-lais-border bg-lais-bg-soft px-4 py-3"
      >
        <h3 class="text-[13px] font-semibold text-lais-text">
          {{ previewTitle }}
        </h3>
        <p
          class="mt-2 whitespace-pre-line text-[13px] leading-relaxed text-lais-text-body"
        >
          {{ preview || 'A mensagem será montada com os dados desta visita.' }}
        </p>
      </section>
    </div>

    <template #footer>
      <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <LaisPrimaryButton
          variant="ghost"
          :disabled="loading"
          @click="emit('close')"
        >
          {{ BACK_LABEL }}
        </LaisPrimaryButton>
        <LaisPrimaryButton
          icon="i-lucide-send"
          :is-loading="loading"
          @click="emit('confirm')"
        >
          {{ confirmLabel }}
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisModal>
</template>
